import React from "react";

import { Container } from "./styles";

const CreditCardSVG2 = () => {
  return (
    <Container>
      <svg
        width={20}
        height={20}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 5C0 3.89543 0.895431 3 2 3H22C23.1046 3 24 3.89543 24 5V8H0V5ZM0 10H24V19C24 20.1046 23.1046 21 22 21H2C0.89543 21 0 20.1046 0 19V10ZM4 15C3.44772 15 3 15.4477 3 16C3 16.5523 3.44772 17 4 17H7C7.55228 17 8 16.5523 8 16C8 15.4477 7.55228 15 7 15H4Z"
          fill="var(--text-color)"
        />
      </svg>
    </Container>
  );
};

export default CreditCardSVG2;
